import { render } from "./MalaCats.vue?vue&type=template&id=40f6ab99&scoped=true"
import script from "./MalaCats.vue?vue&type=script&lang=js"
export * from "./MalaCats.vue?vue&type=script&lang=js"

import "./MalaCats.vue?vue&type=style&index=0&id=40f6ab99&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40f6ab99"]])

export default __exports__